/**
 * HouseholdIncomeEditor — v1.0.10 shared Total Household Income edit dialog.
 *
 * One implementation for every household size: HouseholdOverviewCard (group
 * households) and SoloHouseholdIncomeCard (single-applicant screenings) both
 * render this. Manual entry only — the individual-income sum is informational
 * and never auto-fills the field.
 */
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

export default function HouseholdIncomeEditor({ open, onOpenChange, value, individualSum, onSave, busy }) {
  const [draft, setDraft] = useState(value != null ? String(value) : "");
  return (
    <Dialog open={open} onOpenChange={(o) => { if (o) setDraft(value != null ? String(value) : ""); onOpenChange(o); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif text-xl">Total Household Income</DialogTitle>
          <DialogDescription>
            Household-level monthly income entered by NTN staff. This value is stored
            independently and is never auto-calculated from individual applicant incomes.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Input type="number" min="0" step="0.01" value={draft}
                 onChange={(e) => setDraft(e.target.value)}
                 placeholder="e.g. 8000" className="rounded-sm h-11"
                 data-testid="household-income-input" />
          <p className="text-xs text-slate-500" data-testid="household-income-hint">
            For reference only — sum of individual applicant incomes:{" "}
            <strong>${(individualSum || 0).toLocaleString()}</strong>/mo (active members). Leave blank to clear.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm"
                  data-testid="household-income-cancel">Cancel</Button>
          <Button onClick={() => onSave(draft === "" ? null : parseFloat(draft))} disabled={busy}
                  className="bg-[#0A192F] rounded-sm" data-testid="household-income-save">
            {busy ? "Saving…" : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
